import React, { useState, useEffect } from "react";

export default function BuyerRfqRejectionModal({
  show,
  rfq,
  title,
  description,
  onConfirm,
  onCancel,
}) {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  useEffect(() => {
    setReason("");
    setCustomReason("");
  }, [show]);

  if (!show || !rfq) return null;

  const handleConfirm = () => {
    let finalReason = reason;

    if (reason === "others") {
      if (!customReason.trim()) {
        return;
      }
      finalReason = customReason;
    }

    onConfirm(finalReason);
  };

  return (
    <div
      className="modal fade show d-block"
      style={{
        background: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 1200,
      }}
      onClick={onCancel}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content p-4 rounded-3">

          {/* Icon */}
          <div className="d-flex justify-content-center mb-3">
            <img
              src="/images/remove.svg"
              alt={rfq.requirementId}
              className="rounded-circle"
              width={90}
              height={90}
            />
          </div>

          {/* Title */}
          <h5 className="fw-bold mb-2" style={{ color: "#071437" }}>
            {title || "You’re about to reject an RFQ."}
          </h5>

          {/* Description */}
          <p style={{ color: "#80829A", fontSize: "14px" }}>
            {description ||
              `Are you sure you want to reject ${rfq.requirementId}? This action cannot be undone.`}
          </p>

          {/* Dropdown */}
          <label className="form-label" style={{ color: "#181D4C" }}>
            Select Reason
          </label>
          <select
            className="form-select mb-3"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="">Select a reason</option>
            <option value="capacity">Rejecting due to capacity</option>
            <option value="capability">Rejecting due to capability</option>
            <option value="others">Others</option>
          </select>

          {/* Conditional Textarea */}
          {reason === "others" && (
            <textarea
              className="form-control mb-3"
              rows="3"
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              placeholder="Please specify your reason"
            />
          )}

          {/* Buttons */}
          <div className="d-flex justify-content-evenly gap-2">
            <button className="btn w-100 btn-outline-dark" onClick={onCancel}>
              Cancel
            </button>
            <button
              className="btn w-100"
              style={{ backgroundColor: "#181D4C", color: "#fff" }}
              onClick={handleConfirm}
            >
              Confirm Rejection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
